module.exports = __webpack_public_path__ + "static/media/united-kingdom.aab35bf9.svg";